<template>
  <div style="margin-top: 5px;">
    {{valueFormatted}}
  </div>
</template>

<script>
  export default {
    name: "timesheet-field-duration-total",
    props: {
      layout: {
        type: Object,
        required: true
      },
      value: {
        type: Number,
        default: 0
      }
    },
    data() {
      return {
        layoutData: this.layout,
        valueData: this.value
      }
    },
    watch: {
      value(newval) {
        this.valueData = newval;
      }
    },
    computed: {
      fieldType() {
        return this.layoutData.type
      },
      fieldLabel() {
        return this.layoutData.label
      },
      valueFormatted() {
        if(this.valueData == null) return "0.00 heures";
        return this.valueData.toFixed(2) + " heures";
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>